if (!customElements.get('dormere-mattress-layers')) {
  customElements.define('dormere-mattress-layers', class extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      const initial = this.querySelector('[data-dml-trigger][aria-expanded="true"]');
      this.setActive(initial?.dataset.dmlTrigger || null);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.clearTimeout(this.scrollTimer);
    }

    handleClick(event) {
      const hotspot = event.target.closest('[data-dml-target]');
      const trigger = event.target.closest('[data-dml-trigger]');
      if (hotspot && this.contains(hotspot)) {
        window.clearTimeout(this.scrollTimer);
        const id = hotspot.dataset.dmlTarget;
        const matchingTrigger = this.triggerFor(id);
        const wasOpen = matchingTrigger?.getAttribute('aria-expanded') === 'true';
        this.setActive(id);

        if (event.detail === 0) matchingTrigger?.focus({ preventScroll: true });

        if (window.matchMedia('(max-width: 900px)').matches) {
          const item = matchingTrigger?.closest('.dml__item');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // Wait for the height animation, then center the opened card in the viewport.
          this.scrollTimer = window.setTimeout(() => {
            if (!item?.isConnected || matchingTrigger.getAttribute('aria-expanded') !== 'true') return;
            item.scrollIntoView({
              behavior: reducedMotion ? 'auto' : 'smooth',
              block: 'center'
            });
          }, wasOpen || reducedMotion ? 0 : 320);
        }
      } else if (trigger && this.contains(trigger)) {
        window.clearTimeout(this.scrollTimer);
        const id = trigger.dataset.dmlTrigger;
        this.setActive(trigger.getAttribute('aria-expanded') === 'true' ? null : id);
      }
    }

    handleBlockSelect(event) {
      const block = event.target.closest('.dml__item');
      if (!block || !this.contains(block)) return;
      const trigger = block.querySelector('[data-dml-trigger]');
      if (trigger) this.setActive(trigger.dataset.dmlTrigger);
    }

    triggerFor(id) {
      return Array.from(this.querySelectorAll('[data-dml-trigger]'))
        .find((trigger) => trigger.dataset.dmlTrigger === id);
    }

    setActive(id) {
      this.querySelectorAll('[data-dml-trigger]').forEach((trigger) => {
        const active = trigger.dataset.dmlTrigger === id;
        trigger.setAttribute('aria-expanded', String(active));
        trigger.closest('.dml__item')?.classList.toggle('is-active', active);
      });

      this.querySelectorAll('.dml__content').forEach((panel) => {
        const active = panel.id === id;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });

      this.querySelectorAll('[data-dml-target]').forEach((hotspot) => {
        const active = hotspot.dataset.dmlTarget === id;
        hotspot.classList.toggle('is-active', active);
        hotspot.setAttribute('aria-expanded', String(active));
      });
    }
  });
}
